import axios from 'axios'
import urls from './urls'
import querystring from 'querystring'

const getLastLocations = async function (idShipment, size) {
  try {
    var filters = {
      size: size
    }
    const res = await axios.get(urls.getLastLocations(idShipment) + '?' + querystring.stringify(filters))
    return Promise.resolve(res.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export {
  getLastLocations,
}
